export default __webpack_public_path__ + "static/media/1.3a574896.png";